
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { useState } from 'react';
import {
  Table,
  THead,
  TCell,
  TRow,
  TBody,
  EmptyState,
  Checkbox,
  Input,
  Size,
} from '@drawbotics/react-drylus';
import sv from '@drawbotics/drylus-style-vars';
import Playground, { PropsTable } from '~/components/Playground';
export const family = [{
  id: 1,
  name: 'Mike',
  age: 35,
  height: '180cm',
  children: 2,
  _id: 'blabla',
  data: [{
    name: 'Johnny',
    _id: 'blabla',
    age: 5,
    height: '120cm',
    children: 0
  }, {
    name: 'Laura',
    age: 10,
    height: '150cm',
    children: 0
  }]
}, {
  id: 2,
  name: 'Claire',
  age: 20,
  height: '170cm',
  children: 1,
  data: [{
    name: 'Timmy',
    age: 3,
    height: '70cm',
    children: 0
  }]
}, {
  id: 3,
  name: 'David',
  age: 44,
  height: '190cm',
  children: 2,
  data: [{
    name: 'Bobby',
    age: 16,
    height: '160cm',
    children: 0
  }, {
    name: 'Julie',
    age: 20,
    height: '167cm',
    children: 1
  }]
}, {
  id: 4,
  name: 'Trevor',
  age: 44,
  height: '190cm',
  children: 2,
  data: [{
    name: 'Blabla',
    age: 16,
    height: '160cm',
    children: 0
  }]
}];
export const SortedWrapper = ({
  render
}) => {
  const [sortedBy, setSortedBy] = useState(null);
  const sortedData = sortedBy ? sortedBy.direction === 'asc' ? family.sort((a, b) => a[sortedBy.key].localeCompare(b[sortedBy.key])) : family.sort((b, a) => a[sortedBy.key].localeCompare(b[sortedBy.key])) : family;
  const handleClickHeader = key => setSortedBy({
    key,
    direction: sortedBy && sortedBy.direction === 'desc' ? 'asc' : 'desc'
  });
  return <div style={{
    background: '#eaeff4',
    padding: '20px',
    margin: '-24px'
  }}>
      {render({
      sortedBy,
      sortedData,
      handleClickHeader
    })}
    </div>;
};
export const data = [{
  id: 1,
  a: 'Data A 1',
  b: 'Data B 1',
  c: 'Data C 1',
  d: 'Data D 1',
  e: 'Data E 1',
  f: 'Data F 1',
  g: 'Data G 1',
  h: 'Data H 1'
}, {
  id: 2,
  a: 'Data A 2',
  b: 'Data B 2',
  c: 'Data C 2',
  d: 'Data D 2',
  e: 'Data E 2',
  f: 'Data F 2',
  g: 'Data G 2',
  h: 'Data H 2'
}, {
  id: 3,
  a: 'Data A 3',
  b: 'Data B 3',
  c: 'Data C 3',
  d: 'Data D 3',
  e: 'Data E 3',
  f: 'Data F 3',
  g: 'Data G 3',
  h: 'Data H 3'
}, {
  id: 4,
  a: 'Data A 4',
  b: 'Data B 4',
  c: 'Data C 4',
  d: 'Data D 4',
  e: 'Data E 4',
  f: 'Data F 4',
  g: 'Data G 4',
  h: 'Data H 4'
}, {
  id: 5,
  a: 'Data A 5',
  b: 'Data B 5',
  c: 'Data C 5',
  d: 'Data D 5',
  e: 'Data E 5',
  f: 'Data F 5',
  g: 'Data G 5',
  h: 'Data H 5'
}];
export const dataWithCheckbox = [{
  id: 1,
  a: <Checkbox onChange={() => {}} mdxType="Checkbox" />,
  b: 'Data B 1',
  c: 'Data C 1',
  d: 'Data D 1'
}, {
  id: 2,
  a: <Checkbox onChange={() => {}} mdxType="Checkbox" />,
  b: 'Data B 2',
  c: 'Data C 2',
  d: 'Data D 2'
}, {
  id: 3,
  a: <Checkbox onChange={() => {}} mdxType="Checkbox" />,
  b: 'Data B 3',
  c: 'Data C 3',
  d: 'Data D 3'
}, {
  id: 4,
  a: <Checkbox onChange={() => {}} mdxType="Checkbox" />,
  b: 'Data B 4',
  c: 'Data C 4',
  d: 'Data D 4'
}, {
  id: 5,
  a: <Checkbox onChange={() => {}} mdxType="Checkbox" />,
  b: 'Data B 5',
  c: 'Data C 5',
  d: 'Data D 5'
}];
export const OptimizedWrapper = ({
  render
}) => {
  const [tableData, setTableData] = useState(data);
  const onChangeValue = newRow => {
    setTableData(tableData => tableData.map(row => row.id === newRow.id ? newRow : row));
  };
  const renderData = tableData.map(row => ({
    id: row.id,
    a: <Input value={row.a} onChange={v => onChangeValue({
      ...row,
      a: v
    })} size={Size.SMALL} mdxType="Input" />,
    b: <Input value={row.b} onChange={v => onChangeValue({
      ...row,
      b: v
    })} size={Size.SMALL} mdxType="Input" />,
    c: <Input value={row.c} onChange={v => onChangeValue({
      ...row,
      c: v
    })} size={Size.SMALL} mdxType="Input" />,
    d: <Input value={row.d} onChange={v => onChangeValue({
      ...row,
      d: v
    })} size={Size.SMALL} mdxType="Input" />,
    e: <Input value={row.e} onChange={v => onChangeValue({
      ...row,
      e: v
    })} size={Size.SMALL} mdxType="Input" />,
    f: <Input value={row.f} onChange={v => onChangeValue({
      ...row,
      f: v
    })} size={Size.SMALL} mdxType="Input" />,
    g: <Input value={row.g} onChange={v => onChangeValue({
      ...row,
      g: v
    })} size={Size.SMALL} mdxType="Input" />,
    h: <Input value={row.h} onChange={v => onChangeValue({
      ...row,
      h: v
    })} size={Size.SMALL} mdxType="Input" />
  }));
  const memoMapping = tableData;
  // console.log(renderData)
  return <div style={{
    background: '#eaeff4',
    padding: '20px',
    margin: '-24px'
  }}>
      {render({
      data: renderData,
      memoMapping
    })}
    </div>;
};

const layoutProps = {
  family,
SortedWrapper,
data,
dataWithCheckbox,
OptimizedWrapper
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Table`}</h1>
<p>{`Usage`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Table, THead, TCell, TRow, TBody } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<p>{`Here is a simple example of a table. By default it has no elevation. If the table is the only content in the page it can be wrapped in a Panel to add elevation.`}</p>
<Playground __position={0} __code={`<div style={{ background: '#eaeff4', padding: '20px', margin: '-24px' }}>
  <Table>
    <THead>
      <TCell>Name</TCell>
      <TCell>Surname</TCell>
      <TCell>Age</TCell>
    </THead>
    <TBody>
      <TRow>
        <TCell>Nick</TCell>
        <TCell>Jonas</TCell>
        <TCell>20</TCell>
      </TRow>
      <TRow>
        <TCell>Spongebob</TCell>
        <TCell>Squarepants</TCell>
        <TCell>35</TCell>
      </TRow>
    </TBody>
  </Table>
</div>`} component={Table} mdxType="Playground">
  <div style={{
        background: '#eaeff4',
        padding: '20px',
        margin: '-24px'
      }}>
    <Table mdxType="Table">
      <THead mdxType="THead">
        <TCell mdxType="TCell">Name</TCell>
        <TCell mdxType="TCell">Surname</TCell>
        <TCell mdxType="TCell">Age</TCell>
      </THead>
      <TBody mdxType="TBody">
        <TRow mdxType="TRow">
          <TCell mdxType="TCell">Nick</TCell>
          <TCell mdxType="TCell">Jonas</TCell>
          <TCell mdxType="TCell">20</TCell>
        </TRow>
        <TRow mdxType="TRow">
          <TCell mdxType="TCell">Spongebob</TCell>
          <TCell mdxType="TCell">Squarepants</TCell>
          <TCell mdxType="TCell">35</TCell>
        </TRow>
      </TBody>
    </Table>
  </div>
</Playground>
<p>{`Particular rows can also be set as `}<inlineCode parentName="p">{`highlighted`}</inlineCode>{`. This is useful if a row can be "active" and opens a modal or a panel when selected.`}</p>
<Playground __position={1} __code={`<div style={{ background: '#F1F5F9', padding: '20px', margin: '-24px' }}>
  <Table highlighted>
    <THead>
      <TCell>Name</TCell>
      <TCell>Surname</TCell>
      <TCell>Age</TCell>
    </THead>
    <TBody>
      <TRow>
        <TCell>Spongebob</TCell>
        <TCell>Squarepants</TCell>
        <TCell>35</TCell>
      </TRow>
      <TRow>
        <TCell>Nick</TCell>
        <TCell>Jonas</TCell>
        <TCell>20</TCell>
      </TRow>
      <TRow highlighted>
        <TCell>Spongebob</TCell>
        <TCell>Squarepants</TCell>
        <TCell>35</TCell>
      </TRow>
    </TBody>
  </Table>
</div>`} mdxType="Playground">
  <div style={{
        background: '#F1F5F9',
        padding: '20px',
        margin: '-24px'
      }}>
    <Table highlighted mdxType="Table">
      <THead mdxType="THead">
        <TCell mdxType="TCell">Name</TCell>
        <TCell mdxType="TCell">Surname</TCell>
        <TCell mdxType="TCell">Age</TCell>
      </THead>
      <TBody mdxType="TBody">
        <TRow mdxType="TRow">
          <TCell mdxType="TCell">Spongebob</TCell>
          <TCell mdxType="TCell">Squarepants</TCell>
          <TCell mdxType="TCell">35</TCell>
        </TRow>
        <TRow mdxType="TRow">
          <TCell mdxType="TCell">Nick</TCell>
          <TCell mdxType="TCell">Jonas</TCell>
          <TCell mdxType="TCell">20</TCell>
        </TRow>
        <TRow highlighted mdxType="TRow">
          <TCell mdxType="TCell">Spongebob</TCell>
          <TCell mdxType="TCell">Squarepants</TCell>
          <TCell mdxType="TCell">35</TCell>
        </TRow>
      </TBody>
    </Table>
  </div>
</Playground>
<h3>{`Table Row`}</h3>
<PropsTable component={TRow} mdxType="PropsTable" />
<h4>{`Complex example with nested data`}</h4>
<p>{`The following example includes a "manually" built table with nested tables up to 4 levels.`}</p>
<Playground __position={3} __code={`<div style={{ background: '#eaeff4', padding: '20px', margin: '-24px' }}>
  <Table withNesting>
    <THead>
      <TCell>Estate</TCell>
      <TCell>Name</TCell>
      <TCell>Date of creation</TCell>
      <TCell>Items to approve</TCell>
    </THead>
    <TBody>
      <TRow>
        <TCell>18430</TCell>
        <TCell>BNP Paribas</TCell>
        <TCell>Apr 13, 2019</TCell>
        <TCell>5 items</TCell>
      </TRow>
      <TRow>
        <TCell>18430</TCell>
        <TCell>Covivio - Belaia</TCell>
        <TCell>Apr 13, 2019</TCell>
        <TCell>3 items</TCell>
      </TRow>
      <TRow parent="1">
        <TCell>18430</TCell>
        <TCell>BNP Paribas</TCell>
        <TCell>Apr 13, 2019</TCell>
        <TCell>5 items</TCell>
      </TRow>
      <TRow nested="1">
        <TCell>
          <Table>
            <TBody>
              <TRow>
                <TCell>18430-INT1</TCell>
                <TCell>Apartment 3.4</TCell>
                <TCell>Interior 3D</TCell>
              </TRow>
              <TRow>
                <TCell>18430-INT2</TCell>
                <TCell>Apartment 2.4</TCell>
                <TCell>Exterior 3D</TCell>
              </TRow>
              <TRow parent="2">
                <TCell>18430-INT3</TCell>
                <TCell>Apartment 1.4</TCell>
                <TCell>Exterior 3D</TCell>
              </TRow>
              <TRow nested="2">
                <TCell>
                  <Table>
                    <TBody>
                      <TRow parent="3">
                        <TCell>18430-BRD</TCell>
                        <TCell>Cam 1</TCell>
                        <TCell>Brand ID</TCell>
                      </TRow>
                      <TRow nested="3">
                        <TCell>
                          <Table>
                            <TBody>
                              <TRow>
                                <TCell>18430-BRD</TCell>
                                <TCell>Cam 1</TCell>
                                <TCell>Brand ID</TCell>
                              </TRow>
                            </TBody>
                          </Table>
                        </TCell>
                      </TRow>
                      <TRow>
                        <TCell>18430-WEB</TCell>
                        <TCell>Cam 2</TCell>
                        <TCell>Website</TCell>
                      </TRow>
                    </TBody>
                  </Table>
                </TCell>
              </TRow>
            </TBody>
          </Table>
        </TCell>
      </TRow>
      <TRow>
        <TCell>18430</TCell>
        <TCell>Covivio - CB21</TCell>
        <TCell>Apr 13, 2019</TCell>
        <TCell>2 items</TCell>
      </TRow>
    </TBody>
  </Table>
</div>`} mdxType="Playground">
  <div style={{
        background: '#eaeff4',
        padding: '20px',
        margin: '-24px'
      }}>
    <Table withNesting mdxType="Table">
      <THead mdxType="THead">
        <TCell mdxType="TCell">Estate</TCell>
        <TCell mdxType="TCell">Name</TCell>
        <TCell mdxType="TCell">Date of creation</TCell>
        <TCell mdxType="TCell">Items to approve</TCell>
      </THead>
      <TBody mdxType="TBody">
        <TRow mdxType="TRow">
          <TCell mdxType="TCell">18430</TCell>
          <TCell mdxType="TCell">BNP Paribas</TCell>
          <TCell mdxType="TCell">Apr 13, 2019</TCell>
          <TCell mdxType="TCell">5 items</TCell>
        </TRow>
        <TRow mdxType="TRow">
          <TCell mdxType="TCell">18430</TCell>
          <TCell mdxType="TCell">Covivio - Belaia</TCell>
          <TCell mdxType="TCell">Apr 13, 2019</TCell>
          <TCell mdxType="TCell">3 items</TCell>
        </TRow>
        <TRow parent="1" mdxType="TRow">
          <TCell mdxType="TCell">18430</TCell>
          <TCell mdxType="TCell">BNP Paribas</TCell>
          <TCell mdxType="TCell">Apr 13, 2019</TCell>
          <TCell mdxType="TCell">5 items</TCell>
        </TRow>
        <TRow nested="1" mdxType="TRow">
          <TCell mdxType="TCell">
            <Table mdxType="Table">
              <TBody mdxType="TBody">
                <TRow mdxType="TRow">
                  <TCell mdxType="TCell">18430-INT1</TCell>
                  <TCell mdxType="TCell">Apartment 3.4</TCell>
                  <TCell mdxType="TCell">Interior 3D</TCell>
                </TRow>
                <TRow mdxType="TRow">
                  <TCell mdxType="TCell">18430-INT2</TCell>
                  <TCell mdxType="TCell">Apartment 2.4</TCell>
                  <TCell mdxType="TCell">Exterior 3D</TCell>
                </TRow>
                <TRow parent="2" mdxType="TRow">
                  <TCell mdxType="TCell">18430-INT3</TCell>
                  <TCell mdxType="TCell">Apartment 1.4</TCell>
                  <TCell mdxType="TCell">Exterior 3D</TCell>
                </TRow>
                <TRow nested="2" mdxType="TRow">
                  <TCell mdxType="TCell">
                    <Table mdxType="Table">
                      <TBody mdxType="TBody">
                        <TRow parent="3" mdxType="TRow">
                          <TCell mdxType="TCell">18430-BRD</TCell>
                          <TCell mdxType="TCell">Cam 1</TCell>
                          <TCell mdxType="TCell">Brand ID</TCell>
                        </TRow>
                        <TRow nested="3" mdxType="TRow">
                          <TCell mdxType="TCell">
                            <Table mdxType="Table">
                              <TBody mdxType="TBody">
                                <TRow mdxType="TRow">
                                  <TCell mdxType="TCell">18430-BRD</TCell>
                                  <TCell mdxType="TCell">Cam 1</TCell>
                                  <TCell mdxType="TCell">Brand ID</TCell>
                                </TRow>
                              </TBody>
                            </Table>
                          </TCell>
                        </TRow>
                        <TRow mdxType="TRow">
                          <TCell mdxType="TCell">18430-WEB</TCell>
                          <TCell mdxType="TCell">Cam 2</TCell>
                          <TCell mdxType="TCell">Website</TCell>
                        </TRow>
                      </TBody>
                    </Table>
                  </TCell>
                </TRow>
              </TBody>
            </Table>
          </TCell>
        </TRow>
        <TRow mdxType="TRow">
          <TCell mdxType="TCell">18430</TCell>
          <TCell mdxType="TCell">Covivio - CB21</TCell>
          <TCell mdxType="TCell">Apr 13, 2019</TCell>
          <TCell mdxType="TCell">2 items</TCell>
        </TRow>
      </TBody>
    </Table>
  </div>
</Playground>
<h3>{`Auto generated table`}</h3>
<p>{`The above example is very tedious to create by hand, and let's be honest, most tables with this sort of shape will be derived from a set of data. As such, you have access to a special `}<inlineCode parentName="p">{`data`}</inlineCode>{` prop which will contain the data to generate the table.`}</p>
<p>{`Take the following structure representing families and their trees:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`[{
  name: 'Mike',
  age: 35,
  height: '180cm',
  children: 2,
  data: [{
    name: 'Johnny',
    age: 5,
    height: '120cm',
    children: 0,
  }, {
    name: 'Laura',
    age: 10,
    height: '150cm',
    children: 0,
  }],
}, {
  name: 'Claire',
  age: 20,
  height: '170cm',
  children: 1,
  data: [{
    name: 'Timmy',
    age: 3,
    height: '70cm',
    children: 0,
  }],
  // etc
}]
`}</code></pre>

<p>{`Below is the table that it generates. Note that you need to at least pass `}<inlineCode parentName="p">{`header`}</inlineCode>{` to the table if you want to display something.`}</p>
<Playground __position={4} __code={`<div style={{ background: '#eaeff4', padding: '20px', margin: '-24px' }}>
  <Table
    onEnterRow={console.log}
    onExitRow={console.log}
    data={family}
    header={[{
      label: 'Name',
      value: 'name',
    }, {
      label: 'Height (cm)',
      value: 'height',
    }, {
      label: 'Age (yrs)',
      value: 'age',
    }, {
      label: 'Children',
      value: 'children',
    }]} />
</div>`} mdxType="Playground">
  <div style={{
        background: '#eaeff4',
        padding: '20px',
        margin: '-24px'
      }}>
    <Table onEnterRow={console.log} onExitRow={console.log} data={family} header={[{
          label: 'Name',
          value: 'name'
        }, {
          label: 'Height (cm)',
          value: 'height'
        }, {
          label: 'Age (yrs)',
          value: 'age'
        }, {
          label: 'Children',
          value: 'children'
        }]} mdxType="Table" />
  </div>
</Playground>
<h3>{`Sortable auto generated table`}</h3>
<p>{`You can pass an array of keys (`}<inlineCode parentName="p">{`sortableBy`}</inlineCode>{`) to set which column is sortable in the table. This will enable the header of the column to be "clickable" and an onClick event will be triggered. Only the root data values can be sorted, since the headers correspond to the keys of such values, and not those of the children.`}</p>
<p>{`For the event you should pass a function to the `}<inlineCode parentName="p">{`onClickHeader`}</inlineCode>{` prop, which will return the active column. Note: the table holds no state in regards to the sorting, that's all up to you. Here is an example:`}</p>

<Playground __position={5} __code={`<SortedWrapper render={({ sortedBy, sortedData, handleClickHeader }) => (
  <Table
    activeHeader={sortedBy}
    onClickHeader={handleClickHeader}
    data={sortedData}
    sortableBy={['name', 'height']}
    header={['name', 'height', 'age', 'children']} />
)} />`} mdxType="Playground">
  <SortedWrapper render={({
        sortedBy,
        sortedData,
        handleClickHeader
      }) => <Table activeHeader={sortedBy} onClickHeader={handleClickHeader} data={sortedData} sortableBy={['name', 'height']} header={['name', 'height', 'age', 'children']} mdxType="Table" />} mdxType="SortedWrapper" />
</Playground>
<h3>{`Table with loading UI`}</h3>
<p>{`You can set `}<inlineCode parentName="p">{`isLoading`}</inlineCode>{` to `}<inlineCode parentName="p">{`true`}</inlineCode>{` and display a placeholder table (with the same number of columns as the one you are trying to load). If `}<inlineCode parentName="p">{`header`}</inlineCode>{` is not given, `}<inlineCode parentName="p">{`isLoading`}</inlineCode>{` has no effect.`}</p>
<Playground __position={6} __code={`<div style={{ background: '#eaeff4', padding: '20px', margin: '-24px' }}>
  <Table animated isLoading loadingRows={6} header={[ 'age', 'height', 'something', 'else' ]} />
</div>`} mdxType="Playground">
  <div style={{
        background: '#eaeff4',
        padding: '20px',
        margin: '-24px'
      }}>
    <Table animated isLoading loadingRows={6} header={['age', 'height', 'something', 'else']} mdxType="Table" />
  </div>
</Playground>
<h3>{`Table without content`}</h3>
<p>{`You can set `}<inlineCode parentName="p">{`emptyContent`}</inlineCode>{` to replace the table content and show something else. This is useful when there is no data that can be displayed in the table. By default you should use the `}<a parentName="p" {...{
        "href": "/component-kit/components/empty-state"
      }}><inlineCode parentName="a">{`EmptyState`}</inlineCode></a>{` component, but you can pass anything you want.`}</p>
<Playground __position={7} __code={`<div style={{ background: '#eaeff4', padding: '20px', margin: '-24px' }}>
  <Table header={[ 'age', 'height', 'something', 'else' ]} emptyContent={<EmptyState description="Sorry! This table is empty" />} />
</div>`} mdxType="Playground">
  <div style={{
        background: '#eaeff4',
        padding: '20px',
        margin: '-24px'
      }}>
    <Table header={['age', 'height', 'something', 'else']} emptyContent={<EmptyState description="Sorry! This table is empty" mdxType="EmptyState" />} mdxType="Table" />
  </div>
</Playground>
<h3>{`Large scrollabe table`}</h3>
<p>{`Sometimes there is too much data (columns) that we need to display, and given the limited screen width, the table can be set to `}<inlineCode parentName="p">{`scrollable`}</inlineCode>{` which will set the first and last columns floating to show the user that there is more data.`}</p>

<Playground __position={8} __code={`<div style={{ background: '#eaeff4', padding: '20px', margin: '-24px', whiteSpace: 'nowrap' }}>
  <Table header={[
    { label: 'First column', value: 'a' },
    { label: 'Second column', value: 'b' },
    { label: 'Third column', value: 'c' },
    { label: 'Fourth column', value: 'd' },
    { label: 'Fifth column', value: 'e' },
    { label: 'Sixth column', value: 'f' },
    { label: 'Seventh column', value: 'g' },
    { label: 'Eighth column', value: 'h' },
  ]} data={data} scrollable sortableBy={['b']} />
</div>`} mdxType="Playground">
  <div style={{
        background: '#eaeff4',
        padding: '20px',
        margin: '-24px',
        whiteSpace: 'nowrap'
      }}>
    <Table header={[{
          label: 'First column',
          value: 'a'
        }, {
          label: 'Second column',
          value: 'b'
        }, {
          label: 'Third column',
          value: 'c'
        }, {
          label: 'Fourth column',
          value: 'd'
        }, {
          label: 'Fifth column',
          value: 'e'
        }, {
          label: 'Sixth column',
          value: 'f'
        }, {
          label: 'Seventh column',
          value: 'g'
        }, {
          label: 'Eighth column',
          value: 'h'
        }]} data={data} scrollable sortableBy={['b']} mdxType="Table" />
  </div>
</Playground>

<h3>{`Table with actionable header`}</h3>
<Playground __position={9} __code={`<div style={{ background: '#eaeff4', padding: '20px', margin: '-24px', whiteSpace: 'nowrap' }}>
  <Table header={[
    { label: <Checkbox onChange={() => {}} />, value: 'a' },
    { label: 'Second column', value: 'b' },
    { label: 'Third column', value: 'c' },
    { label: 'Fourth column', value: 'd' },
  ]} data={dataWithCheckbox} />
</div>`} mdxType="Playground">
  <div style={{
        background: '#eaeff4',
        padding: '20px',
        margin: '-24px',
        whiteSpace: 'nowrap'
      }}>
    <Table header={[{
          label: <Checkbox onChange={() => {}} mdxType="Checkbox" />,
          value: 'a'
        }, {
          label: 'Second column',
          value: 'b'
        }, {
          label: 'Third column',
          value: 'c'
        }, {
          label: 'Fourth column',
          value: 'd'
        }]} data={dataWithCheckbox} mdxType="Table" />
  </div>
</Playground>

<h3>{`Optimized table`}</h3>
<p>{`Sometimes we have large tables with a lot of data which can change, and re-rendering the whole table on a single field change can be expensive. Thus you can pass the `}<inlineCode parentName="p">{`memoDataValues`}</inlineCode>{` option to enable memoization of the data, and only the affected rows will be re-rendered. The `}<inlineCode parentName="p">{`memoDataValues`}</inlineCode>{` prop should follow the same shape as the `}<inlineCode parentName="p">{`data`}</inlineCode>{` prop (keys), but only include the values that can be compared for memoization. E.g. on header A we have an `}<inlineCode parentName="p">{`Input`}</inlineCode>{` with value `}<inlineCode parentName="p">{`Data A 1`}</inlineCode>{` but if we want to compare previous/next props, we should pass its raw value in key `}<inlineCode parentName="p">{`a`}</inlineCode>{`, `}<inlineCode parentName="p">{`Data A 1`}</inlineCode>{`. `}</p>
<p><strong parentName="p">{`Optimized`}</strong></p>
<Playground __position={10} __code={`<OptimizedWrapper render={({ data, memoMapping }) => (
  <Table header={['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h']} data={data} memoDataValues={memoMapping} />
)} />`} mdxType="Playground">
  <OptimizedWrapper render={({
        data,
        memoMapping
      }) => <Table header={['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h']} data={data} memoDataValues={memoMapping} mdxType="Table" />} mdxType="OptimizedWrapper" />
</Playground>
<p><strong parentName="p">{`Not optimized`}</strong></p>
<Playground __position={11} __code={`<OptimizedWrapper render={({ data, memoMapping }) => (
  <Table header={['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h']} data={data} />
)} />`} mdxType="Playground">
  <OptimizedWrapper render={({
        data,
        memoMapping
      }) => <Table header={['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h']} data={data} mdxType="Table" />} mdxType="OptimizedWrapper" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;